import React from 'react'
import { Typography as TypographyBase } from "@strapi/design-system/Typography";
import Tooltip from '../Tooltip/Tooltip';

const maxLengthDefault = 26

const Typography = ({
  className,
  ellipsis,
  fontSize,
  fontWeight,
  lineHeight,
  textAlign,
  textColor,
  textTransform,
  variant,
  children,
  as,
  onClick,
}) => {
  const props = {
    className,
    fontSize,
    fontWeight,
    lineHeight,
    textAlign,
    textColor,
    textTransform,
    variant,
    as,
    onClick,
  }

  const maxLengthFinal = ellipsis?.maxLength ?? maxLengthDefault

  const hasEllipsis = () => Boolean(ellipsis && typeof children === 'string' && children.length > maxLengthFinal)

  const getFinalChildren = () => {
    if (hasEllipsis()) {
      return `${children.substring(0, maxLengthFinal)}...`
    }

    return children
  }

  const getTooltipProps = () => {
    if (typeof ellipsis?.tooltip === 'object') {
      return {
        ...ellipsis.tooltip,
        description: ellipsis.tooltip.description ?? children,
      }
    }

    return {
      description: children,
    }
  }

  return (
    <Tooltip visible={hasEllipsis()} {...getTooltipProps()}>
      <TypographyBase {...props}>
        {getFinalChildren()}
      </TypographyBase>
    </Tooltip>
  )
}

export default Typography
